import classNames from 'classnames';
import { ShowHide } from 'components/layout';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';

import './DataDisplay.css';

// Which side each field carries its column gutter on. A table holding a full-width field cannot
// leave this to :nth-child: that field takes a whole row, which flips the gutter side of every
// field after it. Only those tables get their gutter side set explicitly here - a table without
// one emits no gutter class and keeps the :nth-child gutter it has always had.
function buildFieldLayout(data) {
    const fields = data ?? [];
    const hasFullWidthField = fields.some((field) => {
        return field.fullWidth === true;
    });

    let columnIndex = 0;

    return fields.map((field) => {
        if (field.fullWidth) {
            columnIndex = 0;

            return { field: field, fullWidth: true, setGutter: false, gutterOnRight: false };
        }

        const gutterOnRight = columnIndex % 2 === 0;
        columnIndex += 1;

        return { field: field, fullWidth: false, setGutter: hasFullWidthField, gutterOnRight: gutterOnRight };
    });
}

export function DataDisplayTable(
    {
        loading = false,
        displayInRows = true,
        columnsPerRow = 2,
        data
    }
) {
    return (
        <div className={classNames({ "data-display-table-rows": displayInRows, "data-display-table-columns": !displayInRows }, `data-display-table-columns-${columnsPerRow}`)}>
            {buildFieldLayout(data).map(({ field: d, fullWidth, setGutter, gutterOnRight }) => {
                const hasValue = !!d.value || d.value === 0;

                return (
                    <div
                        className={classNames("data-display-table-field form-field", {
                            "data-display-table-no-value": !hasValue,
                            "data-display-table-field-full-width": fullWidth,
                            "data-display-table-field-gutter-right": setGutter && gutterOnRight,
                            "data-display-table-field-gutter-left": setGutter && !gutterOnRight
                        })}
                        key={d.key}
                    >
                        <h4 className={classNames("data-display-table-field-header", { "bp6-skeleton": loading })}>{d.header}</h4>
                        <ShowHide
                            evaluator={hasValue}
                            show={<span className={classNames("data-display-table-field-value", { "bp6-skeleton": loading })}>{d.value}</span>}
                        />
                        {d.additionalData && d.additionalData.map(y => {
                            return (
                                <Fragment key={y.key}>
                                    <h4 className={classNames("data-display-table-field-header data-display-table-additional-field-header", { "bp6-skeleton": loading })}>{y.header}</h4>
                                    <span className={classNames("data-display-table-field-value data-display-table-additional-field-value", { "bp6-skeleton": loading })}>{y.value}</span>
                                </Fragment>
                            );
                        })}
                    </div>
                );
            })}
        </div>
    );
}

DataDisplayTable.propTypes = {
    data: PropTypes.array.isRequired,
    loading: PropTypes.bool,
    displayInRows: PropTypes.bool,
    columnsPerRow: PropTypes.number
};